import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const WheelDriveSpec = ({ wheelDriveSpec }: SpecProps<"wheel_drive_spec">) => {
  const { i18n } = useLingui();

  if (wheelDriveSpec == null || wheelDriveSpec === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.wheel_drive_spec",
    message: "Wheel drive name",
    comment: "Field for 'wheel drive spec' in ad specification",
  });
  return <FieldValuePair field={field} value={wheelDriveSpec} />;
};
